const VibeDetails = () =>{
    return(
        <div>
            Vibe Details
        </div>
    )
}

export default VibeDetails;